import { HOSTING_ENVIRONMENT } from '@verona/utils';

export const getProfileLink = () =>
  'production' === HOSTING_ENVIRONMENT
    ? 'https://profile.veritas.at/profile/user'
    : 'https://profile-stage.veritas.at/profile/user';
